import { observable, action } from 'mobx'
import axios, { post, get } from 'axios'
import moment from 'moment'
import { pick } from 'lodash'
import config from 'react-global-configuration'
import Store from  './_store'
import isEmail from 'validator/lib/isEmail'
import logo from '../../static/logo-stripe.png'

axios.defaults.withCredentials = true
const withCredentials = true

const ENV = (key) => {
  try {
    return config.get(key)
  } catch (e) {
    return {}
  }
}

let stripeHandler = {}
let stripeV3 = {}
try {
  stripeHandler = StripeCheckout.configure({
    key: ENV('stripePK'),
    locale: 'auto'
  })
  stripeV3 = Stripe(ENV('stripePK'), { betas: ['checkout_beta_4'] })
} catch (e) {
  console.warn(e)
}


class UserStore extends Store {
  @observable firstName = null
  @observable email = null
  @observable user = null
  @observable password = null
  @observable passwordRepeat = null
  @observable passwordResetCode = null
  @observable pwdResetLoading = false
  @observable _issuedReferralCode = false
  @observable amount = 50


  constructor(props) {
    super(props)
    this.fetchMe()
  }

  @action issueReferralCode = async () => {
    const that = this
    const data = pick(this, ['email', 'firstName'])

    this.loading = true
    post(ENV('apiDomain')+'/user/issueReferralCode', data, {withCredentials})
    .then(res => {
      that._issuedReferralCode = true
      that.loading = false
    })
    .catch(this.catchError)
  }

  @action login = async () => {
    this.loading = true
    const data = pick(this, ['email', 'password'])
    try {
      const res = await post(`${ENV('apiDomain')}/auth/login`, data, {withCredentials})
      this.user = res.data.user
    } catch (err) {
      this.catchError(err)
    } finally {
      this.loading = false
    }
  }

  @action fetchMe = async () => {
    try {
      const res = await get(`${ENV('apiDomain')}/auth/me`, {withCredentials})
      this.user = res.data
    } catch (err) {
      this.catchError(err)
    }
  }

  @action requestPasswordReset = async () => {
    const data = pick(this, ['email'])
    if (!isEmail(data.email)) { return this.catchError({ message: 'Please enter your Email above.'}) }
    this.pwdResetLoading = true
    const res = await post(`${ENV('apiDomain')}/auth/requestPasswordReset`, data, {withCredentials})
    this.err = null
    this.success = { message: 'Password reset link was sent to your email' }
    this.pwdResetLoading = false
  }

  @action setNewPassword = async () => {
    const data = pick(this, ['passwordResetCode', 'password', 'passwordRepeat'])
    if (data.password && data.password.length < 5) {
      return this.catchError({message: 'Password is too short'})
    }
    if (data.password !== data.passwordRepeat) {
      return this.catchError({message: 'Passwords dont match'})
    }
    try {
      const res = await post(`${ENV('apiDomain')}/auth/setNewPassword`, data, {withCredentials})
      this.passwordResetCode = null
    } catch (err) {
      this.catchError(err)
    }
  }

  @action logout = async () => {
    this.user = null
    const { data } = await post(`${ENV('apiDomain')}/auth/logout`)
    this.success = data
  }

  @action topup = async () => {
    this.loading = true
    const amount = this.amount * 100
    window.gtag('event', 'triggered payment', { event_category: 'account balance' })
    stripeHandler.open({
      name: 'Fake Flight Tickets',
      email: this.user.email,
      image: logo,
      description: `PDF GENERATOR`,
      zipCode: true,
      rememberMe: false,
      amount: amount,
      token: async (token, args) => {
        this.trackConversion({ id: token.id, totalPrice: amount })
        window.gtag('event', 'paid', { event_category: 'account balance' })

        const res = await post(`${ENV('apiDomain')}/user/balanceTopUp`, {
          amount, token
        }, {withCredentials})
        this.fetchMe()
      },
      closed: (a,b,c) => {
        if (!this.token) {
          this.loading = false
          window.gtag('event', 'did not want to pay', { event_category: 'account balance' })
        }
      }
    })
  }

  trackConversion = ({ id, totalPrice }) => {
    if (!totalPrice) { totalPrice = PRICE}
    window.gtag('event', 'conversion', {
      'send_to': 'AW-874844064/j90SCLW4i5UBEKCflKED',
      'value': totalPrice/100,
      'currency': 'USD',
      'transaction_id': id
    })
    window.gtag('event', 'purchase', {
      'value': totalPrice/100,
      'currency': 'USD',
      'transaction_id': id
    })
  }
}

const userStore = new UserStore()
export default userStore



// WEBPACK FOOTER //
// ./src/stores/UserStore.js